var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showFooterBar,
          expression: "showFooterBar"
        }
      ],
      staticClass: "footer-container fixed-bottom bg-white btn-tab-group"
    },
    [
      _c("div", { staticClass: "footer-menu" }, [
        _c(
          "div",
          { staticClass: "footer-row d-flex justify-content-end" },
          [_vm._t("buttons")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }